import { observer } from 'mobx-react-lite';
import Banner from '../components/Banner';
import { useLocation, useNavigate } from 'react-router-dom';
import { ekDomain, ROUTES } from '@/configs/constants';
import HomeIntroduce from '../components/HomeIntroduce';
import HomeListItem from '../components/HomeListItem';
import { advertisementUrl, sampleBannerImages } from './dummy-data';
import { isPathEk } from '@/utils/routes';
import { useStore } from '@/hooks/useStore';
import { useEffect } from 'react';
import { COMMON_TYPE } from '@/types/enums';
import { flowResult } from 'mobx';
import { useTranslation } from 'react-i18next';

export default observer(function GeneralHome() {
    // hook
    const navigate = useNavigate();
    const { pathname } = useLocation();
    const { t } = useTranslation();

    // const
    const isEk = isPathEk(pathname);

    // store
    const {
        newsStore: { newHomes, getNewHomes, setObservable }
    } = useStore();

    // lifecycle
    useEffect(() => {
        onFetch();

        return () => {
            setObservable('newHomes', []);
        };
    }, []);

    // function
    const onFetch = async () => {
        const payload = {
            page: 1,
            size: 6,
            type: isEk ? COMMON_TYPE.EK : COMMON_TYPE.GAS
        };
        await flowResult(getNewHomes(payload));
    };

    const getUrlDetailNew = (item) => {
        if (item?.id) {
            navigate(isEk ?
                `/${ekDomain}/${ROUTES.newsList.hrefEK}/${ROUTES.newsDetail.hrefEK}/${item.id}` :
                `${ROUTES.newsList.href}/${ROUTES.newsDetail.href}/${item.id}`);
        }
    };

    return (
        <div>
            <div className='banner relative'>
                <Banner bannerImages={sampleBannerImages} />
                <div className='absolute bottom-6 left-0 w-full flex md:justify-start justify-center h-fit point-375:max-w-full max-w-[320px] z-[49]'>
                    <div className='md:w-fit w-full mx-2 max-w-full flex flex-wrap justify-center gap-2 rounded-[min(20px,8vw)] bg-[#FFFFFF33] point-375:px-4 px-1 py-5'>
                        <div className='md:w-[320px] w-full max-w-[320px] round-button'>
                            <a href={`/${isEk ? ekDomain + '/' : ''}${ROUTES.locationCurrentList.href}`} className='relative'>
                                <span>{t('words_title.search_by_nearest_location')}</span>
                            </a>
                        </div>
                        <div className='md:w-[320px] w-full max-w-[320px] round-button'>
                            <a href={`/${isEk ? ekDomain + '/' : ''}${ROUTES.locationList.href}`} className='relative'>
                                <span>{t('words_title.search_by_province_region')}</span>
                            </a>
                        </div>
                    </div>

                </div>
            </div>
            <div className='container'>
                <div className='main flex flex-col gap-12 my-12'>
                    <section>
                        <HomeIntroduce
                            advertisementUrl={advertisementUrl}
                            onReadMore={() => {
                            }}
                        />
                    </section>
                    <section>
                        <HomeListItem
                            newsItems={newHomes}
                            onClickItem={(item) => {
                                getUrlDetailNew(item);
                            }}
                            onSeeMore={() => {
                                navigate(isEk ? `/${ekDomain}/${ROUTES.newsList.hrefEK}` : ROUTES.newsList.href);
                            }}
                        />
                    </section>
                </div>
            </div>
        </div>
    );
});
